export enum DateFormatType {
  Workspace = 'workspace',
  Default = 'dd/MM/yyyy',
  US = 'MM/dd/yyyy',
  ISO = 'yyyy-MM-dd',
  Hyphen = 'dd-MM-yyyy',
  Slash = 'yyyy/MM/dd',
  MonthYear = 'MM/yyyy',
  YearMonth = 'yyyy-MM',
  ShortMonthYear = 'MMM yyyy',
  DayMonthYear = 'd MMM, yyyy',
  LongDate1 = 'MMMM d, yyyy',
  LongDate2 = 'MMM dd, yyyy',
  LongDate3 = 'MMMM dd, yyyy',
  ShortWeekDate = 'EEE, d MMM yyyy',
  LongWeekDate = 'EEEE, MMMM d, yyyy',
  ShortWeekShortDate = 'EEE, MMM dd, yyyy',
  DayOnlyLong = 'EEEE, d',
  DayOnlyShort = 'EEE, d',
  Compact = 'yyyyMMdd',
  DayNameLong = 'EEEE',
  DayNameShort = 'EEE',
  MonthNameLong = 'EEEE, MMMM',
  MonthNameShort = 'EEE, MMM',
  MonthDayLong = 'EEEE, MMMM d',
  MonthDayShort = 'EEE, MMM d',
}
